import React, { MouseEventHandler } from 'react';

import { CircleMinusLined, CirclePlusLined } from '@tag/tag-icons';

import { CollapsableType } from './types';
import styles from './section-card.module.scss';


interface ICollapseButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isOpen: boolean;
  collapsable: CollapsableType;
}

export default function CollapseButton({
  onClick,
  isOpen,
  collapsable
}: ICollapseButtonProps) {

  const getCollapseIcon = () => {
    if (collapsable.secondaryIcon) {
      return isOpen ? <CircleMinusLined size='20px' /> : <CirclePlusLined size='20px' />;
    }
    return (
      <span className={styles['ag-section-details__dropdown-icon']} />
    );
  };
  return (
    <button
      type="button"
      className={styles['ag-section-details__button']}
      onClick={onClick}
      disabled={collapsable.disabled}
    >
      <span className={styles['ag-section-details__button-text']}>
        {isOpen ? 'Hide ' : 'Show '}
        {collapsable.buttonText}
      </span>
      {getCollapseIcon()}
    </button>
  );
}
